import { UPDATE_BOOTHS } from './'

export default (boothIndex, data) => ({ type: UPDATE_BOOTHS, boothIndex, data })



// WEBPACK FOOTER //
// ./src/store/actions/updateBooths.js